<section class="about py-10">
  <div class="relative h-[400px] mt-[-7rem] w-full md:block hidden">
    <div class="flex items-center justify-center gap-4 h-full w-full">
      @for(image of heroSectionImages; track i ; let i = $index ){
      <img [src]="image" class="w-[25%] object-cover object-center h-full" alt="heroSectionImages" />
      }
    </div>
    <div class="absolute inset-0 bg-white/60"></div>
    <div class="absolute inset-0 z-20 flex flex-col items-center justify-center gap-3">
      <app-back />

      <h4 class="text-secondary dark:text-[#F2F2F2] text-4xl font-bold">
        {{ "About.Title" | translate }}
      </h4>
    </div>
  </div>

  <div class="container max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <div class="flex flex-col gap-2 mt-10">
      <h4 class="text-center text-3xl font-medium dark:text-[#F2F2F2]">
        {{ "About.Subtitle" | translate }}
      </h4>
      <h5 class="text-center mt-2 text-secondary dark:text-[#CACACA]">
        {{ "About.At" | translate }}
        <span class="text-brand font-medium">
          {{ "About.Logo" | translate }}
        </span>
        {{ "About.Description" | translate }}
      </h5>
    </div>
  </div>
  <div class="bg-[#EFF5FD] dark:bg-second-dark mt-3">
    <div class="container max-w-full mx-auto px-4 py-3 mt-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
      <div>
        <h4 class="text-center text-3xl font-medium dark:text-[#F2F2F2]">
          {{ "About.Why_Choose_Us_Title" | translate }}
        </h4>
        <h3 class="text-center text-secondary py-2 dark:text-white mt-2">
          {{ "About.Why_Choose_Us" | translate }}
        </h3>

        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
          @for(feature of features ; track i ; let i = $index){
          <div class="bg-white rounded-2xl flex px-4 py-6 flex-col items-center gap-2">
            <img [src]="feature.icon" [alt]="feature.alt" />
            <h3 class="text-third text-lg font-medium dark:text-[#F2F2F2] mt-3">
              {{ feature.title | translate }}
            </h3>
            <h3 class="text-secondary text-center text-sm dark:text-white">
              {{ feature.body | translate }}
            </h3>
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="bg-white dark:bg-second-dark mt-1">
    <div class="container max-w-full mx-auto px-4 py-3 mt-2 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
      <div class="flex flex-col gap-2 mt-6">
        <h4 class="text-center text-3xl font-medium dark:text-[#F2F2F2]">
          {{ "About.Our_Misson" | translate }}
        </h4>
        <h5 class="text-center mt-2 text-secondary dark:text-[#CACACA]">
          {{ "About.Misson_Body" | translate }}
          {{ "About.At" | translate }}
          <span class="text-brand font-medium">
            {{ "About.Logo" | translate }}
          </span>
          {{ "About.Misson_SubBody" | translate }}
        </h5>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        @for(offer of offers ; track i ; let i = $index){
        <div class="bg-[#EFF5FD] rounded-2xl flex px-4 py-6 flex-col items-center gap-2">
          <img [src]="offer.icon" [alt]="offer.alt" />
          <h3 class="text-third text-lg font-medium dark:text-[#F2F2F2] mt-1">
            {{ offer.title | translate }}
          </h3>
          <h3 class="text-secondary text-center text-sm dark:text-white">
            {{ offer.body | translate }}
          </h3>
        </div>
        }
      </div>
    </div>
  </div>

  <div class="container max-w-full mx-auto px-4 mt-8 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <div class="relative py-12 rounded-2xl overflow-hidden bg-cover bg-center"
      style="background-image: url('/images/sky.jpg')">
      <div class="absolute inset-0 bg-white/80"></div>

      <div
        class="px-4 relative z-10 h-full flex flex-col gap-4 items-center justify-center justify-between text-center text-white">
        <img src="/icons/BlueLogo.svg" alt="logo" class="w-35" />

        <h2 class="text-black text-3xl dark:text-white font-medium">
          {{ "About.Book_Trip" | translate }}
        </h2>

        <p class="text-secondary text-sm dark:text-white">
          {{ "About.Start_Plan" | translate }}
        </p>

        <button (click)="navigateHome()"
          class="bg-brand text-white px-5 w-full md:w-fit py-2 text-xl rounded-lg font-medium justify-center flex gap-2 items-center">
          <span class="flex gap-2 items-center">
            {{ "About.Start_Trip" | translate }}
          </span>
        </button>
      </div>
    </div>
  </div>
</section>